<template>
 <section class="get-in-touch">
      <div class="container">
        <div class="content-wrapper">
          <h2>{{ $t("getInTouch.title") }}</h2>
          <p>{{ $t("getInTouch.description") }}</p>
          <a href="#" class="btn-style gray">
            {{ $t("getInTouch.buttonText") }}
            <img src="../../assets/images/icon/right-arrow.png" :alt="$t('getInTouch.buttonAlt')" />
          </a>
        </div>
      </div>
    </section>
</template>

<script>
export default{
    name: "GetInTouch"
}
</script>